module.exports = __webpack_public_path__ + "images/help-videos-preview-files-336f7490793d61da7a7340f39c5f7f58.png";